// Internal dependencies
import { stripAllTags } from './utils';

// Define image compare function.
window.jQuery.fn.coca_tripleImageCompare = function( userOptions ) {
	const jquery = window.jQuery;
	const defaultOptions = {
		before_label: 'Before',
		middle_label: 'Middle',
		after_label: 'After',
		classes: [],
		no_overlay: false,
		handle_bottom_only: false,
		badge_image: '',
		badge_position: 'center',
		badge_size: '',
		badge_visibility: 'always',
	};
	const options = jquery.extend( defaultOptions, userOptions );

	return this.each( function() {
		const container = jquery( this );
		const cssPrefix = 'coca-image-compare';

		// Guard against double-initialization (same as regular image-compare).
		if ( container.hasClass( `${ cssPrefix }-triple-container` ) ) {
			return;
		}

		const wrapperClasses = [ ...options.classes ];

		if ( options.handle_bottom_only ) {
			wrapperClasses.push( 'handle-bottom' );
			container.find( '.scroller' ).wrap( '<div class="triple-handle-wrapper"></div>' );
		}

		wrapperClasses.push( `${ cssPrefix }-triple-wrapper` );
		container.wrap( `<div class='${ wrapperClasses.join( ' ' ) }'></div>` );
		container.addClass( `${ cssPrefix }-triple-container` );

		// Badge / Watermark feature.
		if ( options.badge_image && options.badge_image.length ) {
			// Remove any existing badge first to prevent duplicates on re-initialization.
			container.find( '.coca-bais-badge' ).remove();

			const badgePosition = options.badge_position || 'center';
			const badgeEl = jquery( `<div class="coca-bais-badge badge-${ badgePosition }"></div>` );
			badgeEl.append( jquery( options.badge_image ) );
			if ( options.badge_size && options.badge_size !== '' ) {
				const badgeWidth = /^\d+(\.\d+)?$/.test( String( options.badge_size ) ) ? options.badge_size + 'px' : options.badge_size;
				badgeEl.find( 'img' ).each( function() {
					this.style.setProperty( 'width', badgeWidth, 'important' );
					this.style.setProperty( 'height', 'auto', 'important' );
				} );
			}
			if ( options.badge_visibility === 'hover' ) {
				badgeEl.addClass( 'badge-hover' );
			}
			container.append( badgeEl );
		}

		// Add overlay when it permitted showing.
		if ( ! options.no_overlay ) {
			container.append( '<div class="overlay"></div>' );
		}

		// set label with each image.
		const ImageTop = container.find( '.top' );
		const ImageMiddle = container.find( '.middle' );
		const ImageBottom = container.find( '.bottom' );

		const beforeLabel = stripAllTags( options.before_label ) || 'Before';
		const middleLabel = stripAllTags( options.middle_label ) || 'Middle';
		const afterLabel = stripAllTags( options.after_label ) || 'After';

		// ImageTop.append( `<div class="label">${ beforeLabel }</div>` );
		// ImageMiddle.append( `<div class="label">${ middleLabel }</div>` );
		// ImageBottom.append( `<div class="label">${ afterLabel }</div>` );
		// Append labels if show_labels is true
		if ( options.show_labels != '' && options.show_labels !== 'label_hide' ) {
			ImageTop.append( `<div class="label">${ beforeLabel }</div>` );
			ImageMiddle.append( `<div class="label">${ middleLabel }</div>` );
			ImageBottom.append( `<div class="label">${ afterLabel }</div>` );
		}

		// Update labels dynamically if show_labels changes
		container.on( 'show_labels_change', function( event, showLabels ) {
			if ( showLabels ) {
				// Append labels if show_labels is true
				ImageTop.append( `<div class="label">${ beforeLabel }</div>` );
				ImageMiddle.append( `<div class="label">${ middleLabel }</div>` );
				ImageBottom.append( `<div class="label">${ afterLabel }</div>` );
			} else {
				// Remove the labels if show_labels is false
				ImageTop.find('.label').remove();
				ImageMiddle.find('.label').remove();
				ImageBottom.find('.label').remove();
			}
		});
		// set action for resize the triple image compare wrapper.
		jquery( window ).on( 'resize.coca_triple_image_compare', () => {
			// clean pre-defined styles from container.
			container.removeAttr( 'style' );
			container.find( '.top img' ).removeAttr( 'style' );

			if ( container.find( '.top img' ).width() > container.width() ) {
				container.find( '.top img, .middle img, .bottom img' ).css( 'max-width', container.width() );
				container.find( '.top img, .middle img, .bottom img' ).css( 'width', container.width() );
			}

			// Adjust width, height for the container.
			/* eslint-disable-next-line */
			container.attr( 'data-max-width', container.find( '.top img' ).width() );
			/* eslint-disable-next-line */
			container.attr( 'data-height', container.find( '.top img' ).height() );
			const tripleWidth = container.find( '.top img' ).width();
			container.css( 'max-width', tripleWidth );
			container.css( 'height', container.find( '.top img' ).height() );

			// Sync caption wrapper so it matches the container width.
			const captionWrapper = container.closest( '.shortcode-container' ).find( '.coca-bais-caption-wrapper' );
			if ( captionWrapper.length ) {
				captionWrapper.css( 'max-width', tripleWidth );
			}

			container.css( 'opacity', 1 );
		} );

		// I hope this over-commenting helps. Let's do this!
		// Let's use the 'active' variable to let us know when we're using it
		let active = false;

		// and define our dom elements to make it easier to read
		const scrollerMiddle = container.find( '.scroller-middle' );
		const scrollerTop = container.find( '.scroller-top' );

		// Prevent default touch behaviors on scrollers for better mobile dragging
		scrollerMiddle.css({
			'touch-action': 'none',
			'-webkit-touch-callout': 'none',
			'-webkit-user-select': 'none',
			'user-select': 'none'
		});
		scrollerTop.css({
			'touch-action': 'none',
			'-webkit-touch-callout': 'none',
			'-webkit-user-select': 'none',
			'user-select': 'none'
		});

		// Let's use this function
		const scrollIt = function( x ) {
			// Calculate our transform
			const lowestPosition = Math.min( x, container.width() );
			const transform = Math.max( 0, lowestPosition );

			// relates an element's border box to the document original.
			const topOffset = Math.round( scrollerTop.offset().left );
			const middleOffset = Math.round( scrollerMiddle.offset().left );

			// Set variable for scroller with.
			const scroller = 45;
			const scrlHalf = Math.round( scroller / 2 );
			const border = 3;
			let leftOffset = 0;


			// we show all our bottom image but how much of our middle and top,
			// that'll depend on what we're dragging
			// if we're dragging the middle slider
			if ( active === 'middle' ) {
				ImageMiddle.css({
					'width': transform + 'px',
					'clip': `rect(0px, ${container.width()}px, ${container.height()}px, ${ImageTop.width()}px)`,
				});
				scrollerMiddle.css( 'left', `${ transform - scrlHalf }px` );


				// if we're using scroller-middle, middle must always be to the right of top
				if ( topOffset > middleOffset - border ) {
					const topWidth = transform - border;
					leftOffset = transform - ( scrlHalf + border );
					ImageTop.css( 'width', `${ topWidth }px` );
					scrollerTop.css( 'left', `${ leftOffset }px` );
				}
			}

			// if we're dragging the top slider
			if ( active === 'top' ) {
				ImageTop.css( 'width', transform + 'px' );
				ImageMiddle.css({'clip': `rect(0px, ${container.width()}px, ${container.height()}px, ${ImageTop.width()}px)`,});
				scrollerTop.css( 'left', `${ transform - scrlHalf }px` );

				// if we're using scroller-top, top must always be to the left
				if ( topOffset > middleOffset - border ) {
					const middleWidth = transform - border;
					leftOffset = transform - ( scrlHalf - border );
					ImageMiddle.css( 'width', `${ middleWidth }px` );
					scrollerMiddle.css( 'left', `${ leftOffset }px` );
				}
			}

			const totalTopPlusMiddleWidth = ImageTop.width() + ImageMiddle.width();
			const bw = totalTopPlusMiddleWidth - ImageTop.width()
			ImageBottom.css('clip', `rect(0px, ${container.width()}px, ${container.height()}px, ${Math.round(bw)}px)`);
		
		// Update labels and captions visibility dynamically
		cocaTripleImageCaptions(container);
	};

	/**
	 * Dynamically hide/show captions in triple compare slider.
	 *
	 * @param {jQuery} container - The slider container.
	 */
	function cocaTripleImageCaptions(container) {
		const ImageTop = container.find('.top');
		const ImageMiddle = container.find('.middle');
		const ImageBottom = container.find('.bottom');

		const scrollerTop = container.find('.scroller-top');
		const scrollerMiddle = container.find('.scroller-middle');

		const containerWidth = container.width();
		const topLeft = scrollerTop.position().left;
		const middleLeft = scrollerMiddle.position().left;

		// Captions in outer wrapper
		const beforeCaption = container.closest('.coca-bais-caption-wrapper, .label-horizontal-middle').find('.before-image-caption');
		const middleCaption = container.closest('.coca-bais-caption-wrapper, .label-horizontal-middle').find('.middle-image-caption');
		const afterCaption = container.closest('.coca-bais-caption-wrapper, .label-horizontal-middle').find('.after-image-caption');

			// Helper functions
			const hide = (el) => el.css({ opacity: 0, visibility: 'hidden' });
			const show = (el) => el.css({ opacity: 1, visibility: 'visible' });

			// HIDE Before when scrollerTop near left edge
			if (topLeft <= containerWidth * 0.05) {
				hide(beforeCaption);
			} else {
				show(beforeCaption);
			}

			// HIDE Middle when scrollerMiddle near edges
			if (middleLeft <= topLeft + containerWidth * 0.05 || middleLeft >= middleLeft + containerWidth * 0.95) {
				hide(middleCaption);
			} else {
				show(middleCaption);
			}

			// HIDE After when middle scroller near right edge
			if (middleLeft >= containerWidth * 0.95) {
				hide(afterCaption);
			} else {
				show(afterCaption);
			}
		}

		// First, we'll have to set up our event listeners
		// We want to watch for clicks on our scroller
		scrollerMiddle.on( 'mousedown', () => {
			active = 'middle';
			scrollerMiddle.addClass( 'scrolling' );
		} );
		jquery( document.body ).on( 'mouseup', () => {
			active = false;
			scrollerMiddle.removeClass( 'scrolling' );
		} );
		jquery( document.body ).on( 'mouseleave', () => {
			active = false;
			scrollerMiddle.removeClass( 'scrolling' );
		} );

		// We'll have to do the same for our top scroller
		scrollerTop.on( 'mousedown', function() {
			active = 'top';
			scrollerTop.addClass( 'scrolling' );
		} );
		jquery( document.body ).on( 'mouseup', () => {
			active = false;
			scrollerTop.removeClass( 'scrolling' );
		} );
		jquery( document.body ).on( 'mouseleave', () => {
			active = false;
			scrollerTop.removeClass( 'scrolling' );
		} );

		// Let's figure out where their mouse is at
		jquery( document.body ).on( 'mousemove', ( eMouseMove ) => {
			if ( ! active ) {
				return;
			}
			// Their mouse is here...
			let x = eMouseMove.pageX;
			// but we want it relative to our wrapper
			x -= container.offset().left;
			// Okay, let's change our state
			scrollIt( x );
		} );

		// And finally, let's repeat the process for touch events
		// first our middle scroller...
		scrollerMiddle.on( 'touchstart', ( eTouchStart ) => {
			active = 'middle';
			scrollerMiddle.addClass( 'scrolling' );
			if ( eTouchStart.cancelable ) {
				eTouchStart.preventDefault();
			}
			eTouchStart.stopPropagation();
		} );

		// then scroller top, our second scroller
		scrollerTop.on( 'touchstart', ( eTouchStart ) => {
			active = 'top';
			scrollerTop.addClass( 'scrolling' );
			if ( eTouchStart.cancelable ) {
				eTouchStart.preventDefault();
			}
			eTouchStart.stopPropagation();
		} );

		jquery( document.body ).on( 'touchend touchcancel', () => {
			active = false;
			scrollerMiddle.removeClass( 'scrolling' );
			scrollerTop.removeClass( 'scrolling' );
		} );

		jquery( document ).on( 'touchmove', ( eTouchMove ) => {
			if ( ! active ) {
				return;
			}

			// Prevent default to stop scrolling and other gestures
			if ( eTouchMove.cancelable ) {
				eTouchMove.preventDefault();
			}

			// Get touch position
			if ( eTouchMove.touches && eTouchMove.touches.length > 0 ) {
				let x = eTouchMove.touches[ 0 ].pageX;
				const containerOffset = container.offset().left;
				x -= containerOffset;
				
				// Clamp x to valid range to prevent jumping
				x = Math.max( 0, Math.min( x, container.width() ) );
				
				scrollIt( x );
			}
		} );

		// Let's set our opening state based off the width,
		// we want to show a bit of both images so the user can see what's going on
		container.imagesLoaded().done( function() {
			const actualWidth = container.data( 'maxWidth' );
			active = 'middle';
			scrollIt( Math.round( actualWidth ) * 0.7 );
			active = 'top';
			scrollIt( Math.round( actualWidth ) * 0.3 );
			active = false;
		} );

		// Auto Slide Implementation for Triple Slider - Choreographed Sequence
		if ( options.triple_auto_slide_enabled ) {
			let isAutoSliding = true;
			let isPausedByHover = false;
			let userHasInteracted = false;
			let autoSlideRequestId = null;
			let startTime = null;
			let pausedProgress = 0;
			
			const duration = ( options.triple_auto_slide_duration || 6 ) * 1000; // Convert to milliseconds
			
			// Easing function for smooth animation
			const easeInOut = function(t) {
				return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
			};

			// Get current slider positions (0-1)
			const getCurrentPositions = function() {
				const containerWidth = container.width();
				const topPos = parseFloat(scrollerTop.css('left')) + 22.5; // Adjust for handle width
				const middlePos = parseFloat(scrollerMiddle.css('left')) + 22.5;
				return {
					top: containerWidth > 0 ? Math.max(0, Math.min(1, topPos / containerWidth)) : 0,
					middle: containerWidth > 0 ? Math.max(0, Math.min(1, middlePos / containerWidth)) : 0
				};
			};

			// Set slider positions - use internal tracking to avoid interfering with user drag
			const setSliderPositions = function(topProgress, middleProgress) {
				// Don't do anything if user is currently interacting
				if (userHasInteracted) return;
				
				const containerWidth = container.width();
				const topX = topProgress * containerWidth;
				const middleX = middleProgress * containerWidth;
				
				// Store the current active state
				const prevActive = active;
				
				active = 'top';
				scrollIt(topX);
				active = 'middle';
				scrollIt(middleX);
				
				// Restore previous active state if user was dragging
				// Otherwise set to false for auto-slide
				active = prevActive || false;
				
				// Update caption visibility
				cocaTripleImageCaptions(container);
			};

			const animate = function(currentTime) {
				// Immediately bail out if user has started interacting
				if (userHasInteracted) {
					return;
				}
				
				if (!startTime) startTime = currentTime;
				const elapsed = currentTime - startTime;
				let progress = (elapsed / duration) + pausedProgress;

				// Choreographed sequence: 5 steps total (starting from first image)
				// Step 0: Start - first image fully shown (both handles at right: 1, 1)
				// Step 1: ONLY first handle moves left (1→0), second handle FROZEN at 1 → Middle image shows
				// Step 2: ONLY second handle moves left (1→0), first handle FROZEN at 0 → Last image shows
				// Step 3: ONLY second handle moves right (0→1), first handle FROZEN at 0 → Middle image shows again
				// Step 4: ONLY first handle moves right (0→1), second handle FROZEN at 1 → First image shows
				
				// Each step takes 1/5 of the total duration
				const stepDuration = duration / 5;
				const currentStep = Math.floor(elapsed / stepDuration) % 5;
				const stepProgress = (elapsed % stepDuration) / stepDuration;
				const easedProgress = easeInOut(stepProgress);
				
				let topPos, middlePos;
				
				switch(currentStep) {
					case 0: // Start - show first image fully (both handles at 1)
						topPos = 1;
						middlePos = 1;
						break;
						
					case 1: // ONLY first handle moves left, second handle FROZEN → Middle image
						topPos = 1 - (easedProgress * 1); // 1 to 0
						middlePos = 1; // FROZEN - no movement at all
						break;
						
					case 2: // ONLY second handle moves left, first handle FROZEN → Last image
						topPos = 0; // FROZEN - no movement at all
						middlePos = 1 - (easedProgress * 1); // 1 to 0
						break;
						
					case 3: // ONLY second handle moves right, first handle FROZEN → Middle image again
						topPos = 0; // FROZEN - no movement at all
						middlePos = 0 + (easedProgress * 1); // 0 to 1
						break;
						
					case 4: // ONLY first handle moves right, second handle FROZEN → First image
						topPos = 0 + (easedProgress * 1); // 0 to 1
						middlePos = 1; // FROZEN - no movement at all
						break;
				}
				
				setSliderPositions(topPos, middlePos);

				// Continue animation if still sliding
				if (isAutoSliding && !isPausedByHover && !userHasInteracted) {
					autoSlideRequestId = requestAnimationFrame(animate);
				}
			};

			const startAutoSlide = function() {
				if (!isAutoSliding || isPausedByHover) return;
				
				// Always reset start time to current time minus elapsed progress
				// This ensures we resume from exactly where we paused
				startTime = performance.now() - (pausedProgress || 0);
				autoSlideRequestId = requestAnimationFrame(animate);
			};

			const pauseAutoSlide = function() {
				if (autoSlideRequestId) {
					// Store current progress when pausing
					if (startTime) {
						pausedProgress = performance.now() - startTime;
					}
					cancelAnimationFrame(autoSlideRequestId);
					autoSlideRequestId = null;
				}
			};

			// Handle hover events if pause on hover is enabled
			if (options.triple_auto_slide_pause_on_hover !== false) {
				container.on('mouseenter', function() {
					isPausedByHover = true;
					pauseAutoSlide();
				});

				container.on('mouseleave', function() {
					isPausedByHover = false;
					// Only restart if not in the middle of a user interaction timeout
					if (!userHasInteracted && !interactionTimer) {
						startAutoSlide();
					}
				});
			}

			// Handle user interactions - separate start and end
			let interactionTimer = null;
			
			const startInteraction = function() {
				// Immediately stop auto slide
				userHasInteracted = true;
				pauseAutoSlide();
				
				// Clear any pending restart timer
				if (interactionTimer) {
					clearTimeout(interactionTimer);
					interactionTimer = null;
				}
			};
			
			const endInteraction = function() {
				// Only set timer to restart when interaction truly ends
				if (interactionTimer) {
					clearTimeout(interactionTimer);
				}
				
				interactionTimer = setTimeout(() => {
					// Reset everything and restart
					userHasInteracted = false;
					pausedProgress = 0;
					startTime = null;
					isAutoSliding = true;
					interactionTimer = null;
					
					// Only start if not currently paused by hover
					if (!isPausedByHover) {
						startAutoSlide();
					}
				}, 500); // 500ms after touch ends
			};

			// Attach interaction handlers to the handles for mouse
			scrollerTop.on('mousedown', startInteraction);
			scrollerMiddle.on('mousedown', startInteraction);
			jquery(document.body).on('mouseup', function() {
				if (userHasInteracted) {
					endInteraction();
				}
			});
			
			// For touch: start on touchstart, end on touchend
			scrollerTop.on('touchstart.autoslide', function(e) {
				startInteraction();
			});
			
			scrollerMiddle.on('touchstart.autoslide', function(e) {
				startInteraction();
			});
			
			// Only restart auto slide when touch actually ends
			jquery(document.body).on('touchend.autoslide touchcancel.autoslide', function() {
				if (userHasInteracted) {
					endInteraction();
				}
			});

			// Start auto slide
			startAutoSlide();
		}

		const observer = new window.MutationObserver( function( mutations ) {
			mutations.forEach( function( mutation ) {
				if ( mutation.type === 'attributes' ) {
					const actualWidth = mutation.target.dataset.maxWidth;
					active = 'middle';
					scrollIt( Math.round( actualWidth ) * 0.7 );
					active = 'top';
					scrollIt( Math.round( actualWidth ) * 0.3 );
					active = false;
				}
			} );
		} );

		observer.observe( container[ 0 ], {
			attributes: true, //configure it to listen to attribute changes
		} );

		// fire resize event.
		jquery( window ).trigger( 'resize.coca_triple_image_compare' );
	} );
};
